import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import "./styles/IntroductionDisclaimer.scss";
import { INTRODUCTION_DISCLAIMER_CONTENT } from './constants';
import DownloadFormatsContainer from './components/DownloadFormatsContainer';
import { useStateMachine } from 'little-state-machine';
import { updateAction } from 'scenes/ProjectMultiStepForm/store';

const IntroductionDisclaimer = () => {
  const { state, actions } = useStateMachine({ updateAction });

  const toggle = () => {
    actions.updateAction({
      ...state,
      showDownloadFormatsModal: !state.showDownloadFormatsModal,
    });
  }

  return (
    <div className="introduction-disclaimer-container">
      <Modal
        size="lg"
        centered
        isOpen={state.showDownloadFormatsModal}
        toggle={toggle}
        className="response-modal introduction-disclaimer"
      >
        <section className="p-2 p-lg-4">
          <ModalHeader toggle={toggle} className="border-0 m-0 p-0" />
          <ModalBody className="introduction-disclaimer__body m-0 pt-lg-2 pb-lg-4">
            <h4 className="font-weight-bold mb-3">
              <FormattedMessage
                id="ProjectStepFormDisclaimer.title"
                defaultMessage="Información mínima para crear tu proyecto"
              />
            </h4>
            <p className="mb-3">
              <FormattedMessage
                id="ProjectStepFormDisclaimer.description"
                defaultMessage="Ten a la mano estos datos para completar el formulario de manera rápida:"
              />
            </p>
            <ul>
              {INTRODUCTION_DISCLAIMER_CONTENT.map((item) => (
                <li key={item.id}>{item.title}</li>
              ))}
            </ul>
            <span className='mb-1 d-block text-center'>
              <FormattedMessage
                id="ProjectStepFormDisclaimer.authorization"
                defaultMessage="<strong>Autorización del cliente:</strong> si ya cuentas con la autorización, tenla lista en un archivo JPEG, DOCX o PDF."
                values={{
                  strong: (...chunks) => <strong>{chunks}</strong>,
                  br: <br />,
                }}
              />
            </span>
            <DownloadFormatsContainer />
          </ModalBody>
        </section>
      </Modal>
    </div>
  );
}

export default IntroductionDisclaimer